export default __webpack_public_path__ + "static/media/company.b4a55097.png";